import { NavLink, useLocation, useHistory } from "react-router-dom";
import * as H from "history";


export const AccountPageComponent = (props: { children: any }) => (
    <div className={"container account-page-container"}>
        <div className={"row"}>
            {props.children}
        </div>
    </div>
);

export const Menu = (props: { children: any }) => (
    <nav aria-label="account page navigation" className={"account-page-menu-container"}>
        <ul className={"nav-menu"}>
            {props.children}
        </ul>
    </nav>
);
export const MenuItem = (props: { children: any, to?: string, exact?: boolean, onClick?: () => void, isActive?: string }) => (
    <>
        {props.onClick && (
            <li className={"nav-item"}>
                <a href={"#"} className={"nav-link"} onClick={props.onClick}>
                    {props.children}
                </a>
            </li>
        )}
        {!props.onClick && (
            <li className={"nav-item"}>
                <NavLink to={props.to ?? "/"} isActive={(match, location) => {
                    if (props.isActive && props.to && props.to.includes(props.isActive)) {
                        return location.pathname.includes(props.isActive);
                    }
                    return match != null;
                }}
                    className={"nav-link"} activeClassName={"active"} exact={props.exact}>
                    {props.children}
                </NavLink>
            </li>
        )}
    </>
);

export const Content = (props: { children: any }) => (
    <div className={"account-page-content-col"}>
        <div className={"account-content-container"}>
            {props.children}
        </div>
    </div>
)
export const ContentTabs = (props: { children: any }) => (
    <div className="tabbar-container">
        <ul className="nav nav-tabs cashier-popup">
            {props.children}
            <li className={"nav-item fill-out"}></li>
        </ul>
    </div>
)
export const ContentTabLink = (props: { children: any, to: string, exact?: boolean }) => {
    const location = useLocation();
    const history = useHistory();
    let className = toActiveClass("nav-item", location, props.to, props.exact);
    return (
        <li className={className} onClick={() => history.push(props.to)}>
            <a className="nav-link">{props.children}</a>
        </li>
    )
}
export const toActiveClass = (className: string, location: H.Location<any>, to: string, exact?: boolean) => {
    if (exact && to === location.pathname) {
        return className + " active";
    } else if (!exact && location.pathname.startsWith(to)) {
        return className + " active";
    }
    return className;
}
export const AccountCard = (props: { onClick?: () => void; children: any, className?: string }) => (
    <div className={"account-card " + (props.onClick ? "clickable " : "") + (props.className ?? "")} onClick={() => props.onClick?.()}>
        {props.children}
    </div>
)

export const MenuWithdrawIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_299_1185)">
                <path d="M2.08781 3.89009L9.56088 2.31397L8.70115 0.820658C8.65921 0.747817 8.60335 0.683951 8.53673 0.632707C8.47011 0.581462 8.39404 0.543842 8.31289 0.521996C8.23173 0.500149 8.14706 0.494504 8.06372 0.505384C7.98037 0.516262 7.9 0.543452 7.82716 0.585399L2.08781 3.89009Z" fill="white" />
                <path d="M3.24818 4.29933H11.7198L11.4505 3.20207C11.4117 3.04025 11.3111 2.90005 11.1702 2.81147C11.0293 2.72289 10.8593 2.69296 10.6967 2.72806L10.5556 2.7584L3.24818 4.29933Z" fill="white" />
                <path d="M11.3398 12.4595C11.0004 12.4592 10.6751 12.3242 10.4351 12.0842C10.1951 11.8442 10.0601 11.5189 10.0598 11.1795V9.25951C10.0601 8.92012 10.1951 8.59475 10.4351 8.35477C10.6751 8.11479 11.0004 7.97983 11.3398 7.97946H14.2603V5.5794C14.2601 5.40971 14.1926 5.24703 14.0726 5.12705C13.9526 5.00707 13.7899 4.9396 13.6202 4.93945H1.13995C0.97026 4.93957 0.807556 5.00702 0.687568 5.12702C0.567583 5.247 0.50012 5.40971 0.5 5.5794V14.8596C0.500201 15.0293 0.567687 15.1919 0.687659 15.3119C0.807628 15.4319 0.970285 15.4994 1.13995 15.4996H13.6205C13.7902 15.4994 13.9529 15.4319 14.0729 15.312C14.1929 15.192 14.2604 15.0293 14.2606 14.8596V12.4595H11.3398Z" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3398 8.61941H14.8599C14.9439 8.61941 15.0273 8.63596 15.105 8.66813C15.1826 8.7003 15.2532 8.74745 15.3126 8.80689C15.372 8.86633 15.4192 8.9369 15.4513 9.01456C15.4835 9.09222 15.5 9.17545 15.5 9.25949V11.1787C15.5 11.2628 15.4834 11.346 15.4513 11.4237C15.4191 11.5013 15.3719 11.5719 15.3125 11.6313C15.2531 11.6907 15.1825 11.7379 15.1048 11.77C15.0272 11.8022 14.9439 11.8187 14.8599 11.8187H11.3398C11.1701 11.8187 11.0073 11.7513 10.8873 11.6312C10.7673 11.5112 10.6999 11.3485 10.6999 11.1787V9.25949C10.6999 9.17545 10.7164 9.09222 10.7485 9.01456C10.7807 8.9369 10.8278 8.86633 10.8873 8.80689C10.9467 8.74745 11.0172 8.7003 11.0949 8.66813C11.1725 8.63596 11.2558 8.61941 11.3398 8.61941ZM11.7627 10.8188C11.8811 10.8979 12.0203 10.9401 12.1627 10.9401C12.3537 10.9401 12.5368 10.8643 12.6718 10.7292C12.8069 10.5942 12.8827 10.4111 12.8827 10.2201C12.8827 10.0777 12.8405 9.93848 12.7614 9.82007C12.6823 9.70166 12.5698 9.60938 12.4382 9.55488C12.3067 9.50038 12.1619 9.48612 12.0222 9.51389C11.8825 9.54168 11.7542 9.61026 11.6536 9.71096C11.5529 9.81166 11.4843 9.93995 11.4565 10.0796C11.4287 10.2193 11.443 10.3641 11.4975 10.4957C11.552 10.6272 11.6443 10.7397 11.7627 10.8188Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_299_1185">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}